import script from "./BaseFileInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFileInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseFileInput.vue?vue&type=style&index=0&id=052741aa&lang=scss"

const __exports__ = script;

export default __exports__